// FILECONTENT_START src/common/components/Spacer/index.ts
import Spacer from "./Spacer";
export default Spacer;

// FILECONTENT_END src/common/components/Spacer/index.ts